(function($) {
    'use strict';
    var ModuleName = 'int_lnls';

    var Module = function(element, options) {
        this.ele = element;
        this.$ele = $(element);
        this.option = options;
    };

    Module.DEFAULT = {

    };

    Module.prototype.init = function() {
    	var self = this;
    	var $this = this.$ele;
    	var $input = $this.find('input');

    	$input.focusin(function() {
    		$this.addClass('focus');
    	});
    	$input.focusout(function() {
    		$this.removeClass('focus');
    	})
    }

    Module.prototype.setInputData = function(data) {
        var self = this;
        var $this = this.$ele;
        var $input = $this.find('input');

        if ( data && typeof data == "string" ) {
            $input.eq(0).val(data);
        } else if ( data && typeof data == "object" ) {
            for (var i = 0;  i < data.length; i++) {
                $input.eq(i).val(data[i])
            }
        }
    }

    $.fn[ModuleName] = function(methods, options) {
        return this.each(function() {
            var $this = $(this);
            var module = $this.data(ModuleName);
            var opts = null;
            if (!!module) { 
                if (typeof methods === 'string' && typeof options === 'undefined') {
                    module[methods](); 
                } else if (typeof methods === 'string' && typeof options === 'object') {
                    module[methods](options); 
                } else {
                    console.log('unsupported options!');
                    throw 'unsupported options!';
                }
            } else {
                var opts = $.extend({}, Module.DEFAULT, (typeof methods === 'object' && methods), (typeof options === 'object' && options));
                var module = new Module(this, opts);
                module.init();
                $this.data(ModuleName, module);
            }
        });
    };

})(jQuery);



// WEBPACK FOOTER //
// ./magaele/int_lnls/module.js